<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-text">
      {{ data.headerText }}
    </div>
    <div class="subheader-text">
      {{ data.subheaderText }}
    </div>
  </div>

  <div
    class="dialog-content"
    [formGroup]="form"
  >
    <mojo-editor
      formControlName="comment"
      [placeholder]=" 'Comment'"
      [material]="true"
      [required]="false"
      toolbar=""
    >
    </mojo-editor>

    <div class="move-to-shortlist-modal-buttons">
      <button
        color="accent"
        class="mr-2"
        mat-button
        type="button"
        (click)="closeDialog()"
      >Cancel
      </button>
      <button
        color="primary"
        class="md"
        mat-flat-button
        (click)="onSubmit()"
        type="button"
      >SAVE
      </button>
    </div>

  </div>
</div>
